import React, {useContext, useEffect, useState} from 'react';
import DataTable from 'react-data-table-component';
import { apiRoutes } from '../../../AppSettings';
import { AuthContext } from '../../../contexts/AuthContext';
import axios from 'axios';
import Util from '../../../Util';
import PatientAvatar from './PatientAvatar';

const customStyles = {
    title: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    rows: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    headCells: {
      style: {
        paddingLeft: '15px', // override the cell padding for head cells
        paddingRight: '15px',
        fontWeight: 'bold',
        fontSize: '15px'
      },
    },
    cells: {
      style: {
        paddingLeft: '15px', // override the cell padding for data cells
        paddingRight: '15px',
        paddingTop: '10px', // override the cell padding for data cells
        paddingBottom: '8px',
        fontSize: '15px',
      },
    },
  };

const PatientList = (props) => {
    const { userState } = useContext(AuthContext);
    const [data, setData] = useState([]);

    useEffect(() => {
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'bearer ' + userState.token
            }
        };

        axios.get(apiRoutes.GetAllPatients, options)
            .then((response) => {
                if (response.status === 200) {
                    const data = response.data;
                    setData(data);
                }
        }, (error) => {
            console.log(error);
        });
    }, []);

    
    const getColumns = () => {
        let columns = [];
    
        if(props.columnsToShow == undefined || props.columnsToShow.includes("Patient ID"))
        {
            columns.push({
                name: 'Patient ID',
                selector: 'patientNumber',
                sortable: true,
                width: '150px'
            });
        }

        if(props.columnsToShow == undefined || props.columnsToShow.includes("Patient Name"))
        {
            columns.push({
                name: 'Patient Name',
                selector: 'name',
                sortable: true,
                width: '250px',
                cell: row => <PatientAvatar patient = {row} /> 
            });
        }

        if(props.columnsToShow == undefined || props.columnsToShow.includes("Age"))
        {        
            columns.push({
                name: 'Age',
                selector: 'CreatedDate',
                sortable: true,
                width: '100px',
                cell: row => <div>{Util.getAge(new Date(row.dob), new Date())}</div> 
            });
        }

        if(props.columnsToShow == undefined || props.columnsToShow.includes("Address"))
        {
            columns.push({
                name: 'Address',
                selector: 'address',
                sortable: true,
                width: '300px'
            });
        }

        if(props.columnsToShow == undefined || props.columnsToShow.includes("Phone"))
        {
            columns.push({
                name: 'Phone',
                selector: 'phone',
                sortable: true,
                width: '130px'
            });
        }

        if(props.columnsToShow == undefined || props.columnsToShow.includes("Last Visit"))
        {
            columns.push({
                name: 'Last Visit',
                selector: 'lastVisit',
                sortable: true,
                width: '130px',
                cell: row => <div> {
                                        new Intl.DateTimeFormat("en-GB", {
                                        year: "numeric",
                                        month: "short",
                                        day: "2-digit"
                                        }).format(new Date(row.lastVisit+".000Z"))
                                    }</div> 
            });
        }

        if(props.columnsToShow == undefined || props.columnsToShow.includes("Paid"))
        {
            columns.push({
                name: 'Paid',
                selector: 'amountPaid',
                sortable: true,
                width: '120px',
                right: true,
                cell: row => <div>${row.amountPaid}</div> 
            });
        }

        return columns;
    };

    let columns = getColumns();
    
    return (  
        <div>
            <DataTable
                title={props.title}
                columns={columns}
                data={data}
                customStyles={customStyles}
                pagination
                highlightOnHover={true}
            />
        </div>
    );
}
 
export default PatientList;